var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/smallCross.e040a387.png","uri@3x": __webpack_public_path__ + "static/media/smallCross.afba36ae.png","uri@2x": __webpack_public_path__ + "static/media/smallCross.5ccaeb81.png",
    width: 12,
    height: 10
});